import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";
import Button from "@shared/v2/Button";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

interface ModalProps {
  blocker: {
    state: string;
    reset: () => void;
    proceed: () => void;
  };
  post: object | null;
}

const UnpublishedChangesModal = ({ blocker }: ModalProps) => {
  return (
    <Modal
      show={blocker.state === "blocked"}
      onHide={blocker.reset}
      closeOnEscape={false}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      {/* @ts-expect-error props shouldn't be required */}
      <Modal.Header title="Unpublished Changes" />
      {/* @ts-expect-error props shouldn't be required */}
      <Modal.Body>
        {/* @ts-expect-error props shouldn't be required */}
        <Typography variant="body-m">
          Your roster has changes that have not been published to your Brivity website yet. You can either
          publish now or come back later.
          <br />
          <br />
          Would you like to publish these changes?
        </Typography>
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[8px]">
        {/* @ts-expect-error props shouldn't be required */}
        <Button size="medium" schema="tertiary" onClick={blocker.proceed}>
          Skip For Now
        </Button>
        {/* @ts-expect-error props shouldn't be required */}
        <Button
          size="medium"
          onClick={() => {
            caseTransformingAxios
              .post("/website/crm/publish")
              .then(() => {
                blocker.proceed();
              })
              .catch(() => {
                blocker.proceed();
              });
          }}
        >
          Publish Now
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UnpublishedChangesModal;
